import { defineStore } from 'pinia'
import { IStoreCronState } from './cron.interface'
import CronState from './state'

export const useCronStore = defineStore('cron', {
  state: (): IStoreCronState => ({ ...CronState })
})
